module.exports = __webpack_public_path__ + "img/outline-image-24px.b54adeb4.svg";